import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { forgotPassword } from '../api';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Forgot password state
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await login(email, password);
      if (!success) {
        setError('Invalid email or password');
      }
    } catch (e) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  async function handleForgotPassword(e: React.FormEvent) {
    e.preventDefault();
    if (!forgotEmail) return;
    setForgotLoading(true);
    try {
      await forgotPassword(forgotEmail);
    } catch {}
    setForgotSent(true);
    setForgotLoading(false);
  }

  return (
    <div className="login-container">
      <div className="card login-card">
        <div className="login-header">
          <div className="login-logo-img">
            <img src="/logo.png" alt="Neural Intelligence" />
          </div>
          <h1 className="login-title">Neural Intelligence</h1>
          <p className="login-subtitle">{showForgot ? 'Reset your password' : 'Sign in to your account'}</p>
        </div>

        {showForgot ? (
          forgotSent ? (
            <div>
              <div style={{ padding: '16px', background: 'var(--color-success-light)', border: '1px solid var(--color-success-border)', borderRadius: '8px', marginBottom: '16px', textAlign: 'center' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--color-success)" strokeWidth="2" style={{ margin: '0 auto 8px' }}><path d="M22 2L11 13" /><path d="M22 2L15 22L11 13L2 9L22 2Z" /></svg>
                <p style={{ fontSize: '15px', color: 'var(--color-badge-success-text)', margin: 0, fontWeight: 500 }}>If an account exists with that email, a reset link has been sent.</p>
              </div>
              <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', textAlign: 'center', marginBottom: '16px' }}>Check your inbox and click the link to set a new password.</p>
              <button type="button" className="btn w-full" style={{ background: 'transparent', border: '2px solid var(--color-border)', color: 'var(--color-text-primary)' }} onClick={() => { setShowForgot(false); setForgotSent(false); setForgotEmail(''); }}>
                Back to Sign In
              </button>
            </div>
          ) : (
            <form onSubmit={handleForgotPassword}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="input"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  autoFocus
                />
              </div>
              <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', marginBottom: '16px' }}>Enter your email and we'll send you a link to reset your password.</p>
              <button type="submit" className="btn btn-primary w-full" disabled={forgotLoading || !forgotEmail}>
                {forgotLoading ? (
                  <><span className="spinner spinner-sm" /> Sending...</>
                ) : (
                  'Send Reset Link'
                )}
              </button>
              <button type="button" className="btn w-full" style={{ marginTop: '8px', background: 'transparent', border: 'none', color: 'var(--color-text-secondary)', fontSize: '14px' }} onClick={() => setShowForgot(false)}>
                Back to Sign In
              </button>
            </form>
          )
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {error && (
              <div className="alert alert-danger mb-4">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                <span>{error}</span>
              </div>
            )}
            <button type="submit" className="btn btn-primary w-full" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner spinner-sm" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
            <div style={{ textAlign: 'center', marginTop: '12px' }}>
              <button type="button" onClick={() => setShowForgot(true)} style={{ background: 'none', border: 'none', color: 'var(--color-primary)', fontSize: '14px', cursor: 'pointer', padding: 0 }}>
                Forgot password?
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
